/**
 * Nombor resit yang dijana peranti tanpa bertanya pelayan.
 *
 * Format (ADR-0002): `{outletCode}-{deviceNo}-{YYYYMMDD}-{seq}`
 * Contoh: `KD01-02-20261101-0143`
 *
 * Unik mengikut pembinaan: tiada kiraan berpusat, jadi tiada pertikaian semasa offline.
 * Tarikh dinyatakan dalam zon waktu kedai, bukan UTC, supaya resit tidak menukar tarikh
 * pada 08:00 pagi waktu Malaysia.
 */
const DEFAULT_TIME_ZONE = 'Asia/Kuala_Lumpur';
/** `YYYYMMDD` dalam zon waktu yang diberi. */
export function ymdInZone(date, timeZone = DEFAULT_TIME_ZONE) {
    if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
        throw new TypeError('tarikh tidak sah');
    }
    const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).formatToParts(date);
    const get = (type) => {
        const found = parts.find((part) => part.type === type);
        if (found === undefined) {
            throw new Error(`zon waktu tidak menghasilkan bahagian "${type}"`);
        }
        return found.value;
    };
    return `${get('year')}${get('month')}${get('day')}`;
}
export function buildReceiptNo(input) {
    if (!/^[A-Z0-9]{1,6}$/.test(input.outletCode)) {
        throw new RangeError(`kod cawangan mesti 1–6 aksara A–Z atau 0–9, diterima "${input.outletCode}"`);
    }
    if (!Number.isInteger(input.deviceNo) || input.deviceNo < 1 || input.deviceNo > 99) {
        throw new RangeError(`nombor peranti mesti integer 1–99, diterima ${input.deviceNo}`);
    }
    if (!Number.isInteger(input.seq) || input.seq < 1) {
        throw new RangeError(`urutan resit mesti integer ≥ 1, diterima ${input.seq}`);
    }
    const ymd = ymdInZone(input.date, input.timeZone ?? DEFAULT_TIME_ZONE);
    const device = String(input.deviceNo).padStart(2, '0');
    const seq = String(input.seq).padStart(4, '0');
    return `${input.outletCode}-${device}-${ymd}-${seq}`;
}
//# sourceMappingURL=receipt.js.map